'use strict';

$ = jQuery;

/*
Clique em uma oferta na lista de mais buscadas
*/

$('#jc-offer-slider .offer-card a').on('click', function (event) {
  var label = $(this).data('label');

  var products = [];
  products.push({
    'brand': $(this).parents('.card').attr('data-brand'),
    'id': $(this).parents('.card').attr('data-id'),
    'model': $(this).parents('.card').attr('data-model'),
    'version': $(this).parents('.card').attr('data-version'),
    'category': $(this).parents('.card').attr('data-category'),
    'price': $(this).parents('.card').attr('data-price'),
    'year': $(this).parents('.card').attr('data-year'),
    'fuel': $(this).parents('.card').attr('data-fuel'),
    'transmission': $(this).parents('.card').attr('data-transmission'),
    'doors': $(this).parents('.card').attr('data-doors')
  });

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oferta',
    'eventAction': 'Clique - Card',
    'eventLabel': $(this).parents('.card').attr('data-brand') + ' ' + $(this).parents('.card').attr('data-title'),
    'ecommerce': {
      'click': {
        'actionField': { 'list': 'Home - Mais buscadas' },
        'products': products
      }
    }
  });

  gtag('event', 'Oferta', {
    'eventCategory': 'Oferta',
    'eventAction': 'Clique - Card',
    'eventLabel': $(this).parents('.card').attr('data-brand') + ' ' + $(this).parents('.card').attr('data-title'),
    'ecommerce': {
      'click': {
        'actionField': { 'list': 'Home - Mais buscadas' },
        'products': products
      }
    }
  });

  dataLayerEstadao.push({
    'event': 'genericEvent',
    'genericCategory': 'conversao',
    'genericAction': $(this).parent().data('brand') + ' ' + $(this).parent().data('title'),
    'genericLabel': 'clique',
    'ecommerce': {
      'add': {
        'products': products
      }
    }
  });

  gtag('event', 'conversao', {
    'genericCategory': 'conversao',
    'genericAction': $(this).parent().data('brand') + ' ' + $(this).parent().data('title'),
    'genericLabel': 'clique',
    'ecommerce': {
      'add': {
        'products': products
      }
    }
  });
});

/*
Clique em uma marca específica no slider de marcas
Envia marca para o GTM.
*/

$('.jc-slide-brand a').on('click', function () {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oferta',
    'eventAction': 'Clique - Marca',
    'eventLabel': $(this).attr('data-label')
  });

  gtag('event', 'Oferta', {
    'eventAction': 'Clique - Marca',
    'eventLabel': $(this).attr('data-label')
  });
});

if ($('.jc-card-slider').length > 0) {
  // Impressões de produto
  var products = [];

  $('.offer-card:not(.impression-counted)').each(function (index, element) {
    $(element).addClass('impression-counted');

    products.push({
      'brand': $(element).data('brand'),
      'id': $(element).find('a').data('offer'),
      'model': $(element).data('model'),
      'version': $(element).data('version'),
      'category': $(element).data('category')
    });
  });

  dataLayer.push({
    'event': 'offerImpression',
    'eventCategory': 'Ofertas',
    'eventAction': 'Impressões',
    'ecommerce': {
      'impressions': products
    }
  });

  gtag('event', 'offerImpression', {
    'eventCategory': 'Ofertas',
    'eventAction': 'Impressões',
    'ecommerce': {
      'impressions': products
    }
  });
}